<template>
  <div>
    <el-button class="ml10 down-btn" type="primary" @click="downPdf">
      群体报告下载
    </el-button>
    <ReportListDialog ref="ReportList" :search-params="searchParams" />
  </div>
</template>
<script>
import ReportListDialog from './ReportListDialog.vue'

export default {
  components: {
    ReportListDialog
  },
  props: {
    searchParams: {}
  },
  data() {
    return {
    }
  },
  created() {

  },
  methods: {
    downPdf() {
      this.$refs.ReportList.open()
    }
  }
}
</script>
<style lang="scss" scoped>
.down-btn{
  height: 32px;
  line-height: 10px;
}
</style>
